import React, { Component } from "react"
import PropTypes from "prop-types"
import { handleErrors } from "./../../utils/file_handling.jsx"
import { Spinner } from "./../../components/shared/spinner"
import "./condition-select.scss"
import { plans } from "../../models/plans/"
class ConditionSelect extends Component {
  state = {
    conditionsLoaded: false,
    conditions: null,
    selectedCondition: null,
    selectedStoreName: null
  }

  componentDidMount() {
    fetch("./images/model/plans.json")
      .then(handleErrors)
      .then(res => res.json())
      .then(ignore => {
        // grab storenames from Object.keys(plans) -> [BT, three, etc]
        let storeNames = Object.keys(plans)

        let conditions = storeNames.map(storeName => ({
          id: plans[storeName].conditions[0].conditionData.id,
          name: storeName,
          label: plans[storeName].conditions[0].conditionData.name
        }))

        // Filter out storenames which map to the same condition id
        // This is to fix Virgin which merges the FTTC and FTTP conditions
        conditions = conditions.filter((condition, i) => {
          const foundIndex = conditions.findIndex(
            c => c.label === condition.label
          )
          return foundIndex === i
        })

        //        let res = plans.BT
        // Get the data from conditions that we care about for the selector
        // const conditions = res.conditions
        //   .filter(condition => condition.conditionData.disable !== "true")
        //   .map(condition => ({
        //     id: condition.conditionData.id,
        //     name: condition[0].conditionData.name
        //   }))

        // Put these into the state
        this.setState({
          ...this.state,
          conditionsLoaded: true,
          conditions,
          selectedCondition: conditions[0].id,
          selectedStoreName: conditions[0].name
        })
      })
  }

  handleSubmit = event => {
    event.preventDefault()
    this.props.onStoreNameSet(this.state.selectedStoreName)
    this.props.onConditionSet(this.state.selectedCondition)
  }

  handleConditionChange = event => {
    // makes massive assumption that names are unique!
    let selectedCondition = this.state.conditions.find(
      cond => cond.name === event.target.value
    )

    this.setState({
      ...this.state,
      selectedStoreName: selectedCondition.name,
      selectedCondition: selectedCondition.id // 1 // parseInt(event.target.value)
    })
  }

  renderConditions() {
    const { conditions } = this.state

    return conditions.map(condition => (
      <option value={condition.name} key={condition.name}>
        {condition.label}
      </option>
    ))
  }

  render() {
    const { conditionsLoaded, selectedStoreName } = this.state

    if (!conditionsLoaded) {
      return <Spinner />
    }

    return (
      <div className="conditionSelect">
        <h1>Select Condition:</h1>
        <form onSubmit={this.handleSubmit}>
          <select
            value={selectedStoreName}
            onChange={this.handleConditionChange}
          >
            {this.renderConditions()}
          </select>
          <button type="submit">Continue</button>
        </form>
      </div>
    )
  }
}

// onConditionSet is a function which takes in the condition id selected
//                This needs to then go to the correct component as necessary
ConditionSelect.propTypes = {
  onConditionSet: PropTypes.func.isRequired,
  onStoreNameSet: PropTypes.func.isRequired
}

export default ConditionSelect
